import React from "react";
import { Spinner } from "react-bootstrap";
import Modal from "../../../../Utilities/DraggableModal";
import { AgGridReact } from "ag-grid-react";
import useFetch from "../../../../Utilities/useFetch";

const NCDHistoryModal = ({ show, onHide, debtorID }) => {
  const { data: ncdHistory, loading, error } = useFetch(
    show && debtorID,
    `${process.env.REACT_APP_API_URL}/Claims/GetNCDHistory`,
    "GET",
    null,
    { debtorid: debtorID }
  );

  const columnDefs = [
    { 
      headerName: "Old Date", 
      field: "oldDate", 
      sortable: true, 
      filter: true,
      cellRenderer: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString();
      }
    },
    { 
      headerName: "New Date", 
      field: "newDate", 
      sortable: true, 
      filter: true,
      cellRenderer: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString();
      }
    },
    { headerName: "Collector", field: "collector", sortable: true, filter: true },
    { 
      headerName: "Date Changed", 
      field: "dateChanged", 
      sortable: true, 
      filter: true,
      cellRenderer: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString();
      }
    },
    { headerName: "Workstation", field: "workstation", sortable: true, filter: true }
  ];

  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>NCD History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Loading NCD history...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger">Failed to load NCD history</div>
        ) : !ncdHistory || ncdHistory.length === 0 ? (
          <p>No NCD history available</p>
        ) : (
          <div className="ag-theme-quartz" style={{ height: '300px', width: '100%' }}>
            <AgGridReact
              rowData={ncdHistory}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              domLayout="normal"
              onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NCDHistoryModal;